/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSaveCardSessionRequest
 */
export interface CreateSaveCardSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSessionRequest
     */
    countryCode: CreateSaveCardSessionRequestCountryCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSessionRequest
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSaveCardSessionRequest
     */
    legalEntityId: string;
}


/**
 * @export
 */
export const CreateSaveCardSessionRequestCountryCodeEnum = {
    Es: 'ES',
    Mx: 'MX',
    Ad: 'AD',
    De: 'DE',
    Pe: 'PE',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL'
} as const;
export type CreateSaveCardSessionRequestCountryCodeEnum = typeof CreateSaveCardSessionRequestCountryCodeEnum[keyof typeof CreateSaveCardSessionRequestCountryCodeEnum];


/**
 * Check if a given object implements the CreateSaveCardSessionRequest interface.
 */
export function instanceOfCreateSaveCardSessionRequest(value: object): value is CreateSaveCardSessionRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    return true;
}

export function CreateSaveCardSessionRequestFromJSON(json: any): CreateSaveCardSessionRequest {
    return CreateSaveCardSessionRequestFromJSONTyped(json, false);
}

export function CreateSaveCardSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSaveCardSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'returnUrl': json['returnUrl'],
        'legalEntityId': json['legalEntityId'],
    };
}

export function CreateSaveCardSessionRequestToJSON(json: any): CreateSaveCardSessionRequest {
    return CreateSaveCardSessionRequestToJSONTyped(json, false);
}

export function CreateSaveCardSessionRequestToJSONTyped(value?: CreateSaveCardSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCode': value['countryCode'],
        'returnUrl': value['returnUrl'],
        'legalEntityId': value['legalEntityId'],
    };
}

